<template>
  <div
    ref="searchOverlay"
    class="fixed hidden inset-0 z-[70]"
    role="dialog"
    aria-modal="true"
  >
    <!-- 背景遮罩 (白色不透明度高) -->
    <div
      class="fixed inset-0 transition-opacity opacity-0 bg-white/95 backdrop-blur-md"
      ref="searchBackdrop"
    ></div>

    <!-- 搜尋內容容器 -->
    <div
      class="relative z-10 w-full max-w-3xl px-5 pt-20 mx-auto transition-all duration-300 -translate-y-10 opacity-0"
      ref="searchPanel"
    >
      <!-- 關閉按鈕 -->
      <button
        @click="Close"
        class="absolute p-2 text-gray-400 transition-colors top-6 right-5 md:right-0 hover:text-black"
      >
        <svg
          class="w-8 h-8"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>

      <!-- 搜尋輸入框 -->
      <div class="relative mb-10">
        <input
          type="text"
          id="globalSearchInput"
          ref="searchInput"
          v-model="key_word"
          @change="Search"
          placeholder="搜尋商品名稱、分類或關鍵字..."
          class="w-full py-4 pr-12 text-2xl font-bold placeholder-gray-300 transition-colors bg-transparent border-b-2 border-gray-200 md:text-3xl focus:border-black focus:outline-none"
        />
        <button class="absolute right-0 text-gray-400 -translate-y-1/2 top-1/2">
          <svg
            class="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            ></path>
          </svg>
        </button>
      </div>

      <!-- 搜尋結果區域 -->
      <div
        id="searchResultsArea"
        class="h-[60vh] overflow-y-auto no-scrollbar pb-20"
      >
        <!-- 預設狀態：熱門關鍵字 -->
        <div id="defaultSearchContent" class="">
          <h3
            class="mb-4 text-xs font-bold tracking-wider text-gray-400 uppercase"
          >
            熱門搜尋
          </h3>
          <div class="flex flex-wrap gap-3">
            <button
              v-for="(item, item_index) in keyword_data"
              :key="`keyword_${item_index}`"
              @click="(key_word = item.Text), Search()"
              class="px-4 py-2 text-sm text-gray-600 transition-colors bg-gray-100 rounded-full hover:bg-black hover:text-white"
            >
              {{ item.Text }}
            </button>
          </div>
        </div>

        <!-- 動態結果列表 (初始隱藏) -->
        <div id="dynamicResults" class="hidden space-y-2">
          <!-- JS 將在此插入結果 -->
        </div>

        <!-- 無結果提示 (初始隱藏) -->
        <div id="noResults" class="hidden py-10 text-center text-gray-500">
          找不到相關商品，請嘗試其他關鍵字。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainDialog",
  data() {
    return {
      key_word: "",
    };
  },
  methods: {
    OpenDialog() {
      const searchOverlay = this.$refs.searchOverlay;
      const searchBackdrop = this.$refs.searchBackdrop;
      const searchPanel = this.$refs.searchPanel;
      const searchInput = this.$refs.searchInput;

      searchOverlay.classList.remove("hidden");
      // 動畫效果
      setTimeout(() => {
        searchBackdrop.classList.remove("opacity-0");
        searchPanel.classList.remove("-translate-y-10", "opacity-0");
      }, 10);
      // 自動聚焦輸入框
      setTimeout(() => {
        searchInput.focus();
      }, 300);
    },
    CloseDialog() {
      this.key_word = "";
      const searchOverlay = this.$refs.searchOverlay;
      const searchBackdrop = this.$refs.searchBackdrop;
      const searchPanel = this.$refs.searchPanel;
      searchBackdrop.classList.add("opacity-0");
      searchPanel.classList.add("-translate-y-10", "opacity-0");
      setTimeout(() => {
        searchOverlay.classList.add("hidden");
        // 重置搜尋狀態
      }, 300);
    },
    Close() {
      this.$store.commit("SetSearchDialog", false);
    },
    Search() {
      if (this.key_word != "") {
        this.$router.push(`/collections?keyword=${this.key_word}`);
        this.Close();
        this.key_word = "";
      }
    },
  },
  watch: {
    dialog_status() {
      this.dialog_status ? this.OpenDialog() : this.CloseDialog();
    },
  },
  computed: {
    dialog_status() {
      return this.$store.state.search_dialog;
    },
    keyword_data() {
      return this.$store.state.keyword_data;
    },
  },
};
</script>
